// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/iconfont.css'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

import echarts from 'echarts' // 引入echarts
Vue.use(echarts)
Vue.prototype.$echarts = echarts

import qs from 'qs';
Vue.prototype.$qs = qs

import axios from 'axios';
axios.defaults.baseURL = "http://testopenapi.delib2b.com/clue/" //  测试
// axios.defaults.baseURL = "http://erpapi.delib2b.com/clue/" //生产

axios.interceptors.request.use((config) => {
    let token = window.localStorage.getItem("token");
    config.headers['Authorization'] = token;
    return config;
}, function (error) {
    console.error("请求调用失败", error);
    return Promise.reject(error);
});

/* 响应拦截器 */
axios.interceptors.response.use(function (response) {
    if (response.data.resultCode == 10010 || response.data.resultCode == 702) {
        console.log(response.data.resultCode)
        Vue.prototype.$message({
            type: "warning",
            message: response.data.resultMessage
        });
        window.localStorage.setItem("token", "");
        router.push({
            path: '/login' // 到登录页重新获取token
        })
    }
    return response
}, function (error) {
    return Promise.reject(error)
})

Vue.prototype.$http = axios; //全局注册，使用方法为:this.$http

router.beforeEach((to, from, next) => {
    if (to.name == 'loginThirdParty') {
        next();
        return;
    }
    const auth = localStorage.getItem('token'); //获取token
    const userType = localStorage.getItem('userType'); //获取登录人的身份标识

    console.log(userType)
    if (!auth && to.name !== 'login') {
        next({
            name: 'login'
        });
    } else {
        if (to.name == 'homePage' && userType == '7') { //管理员
            next({
                name: 'accountManage'
            });
        }
        if (to.name == 'homePage' && userType == '6') { //财务部成员
            next({
                name: 'clueView'
            });
        }
        if (to.name == 'homePage' && userType == '5') { //商务支持部其他成员
            next({
                name: 'clueView'
            });
        }
        if (to.name == 'homePage' && userType == '8') { //商品部 
            next({
                name: 'clueUpdateT'
            });
        }
        if (to.name == 'homePage' && userType == '9') { //分公司管理中心
            next({
                name: 'clueUpdateT'
            });
        }
        next();
    }
    // to 和 from 都是 路由信息对象
});
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js